<template>
    <UiTable :blok="blok" class="w-full" />
</template>

<script setup lang="ts">
import type { ITable } from '@nuxt-monorepo/ui/types/components/Table';

defineProps<{ blok: ITable }>();
</script>

<style lang="postcss" scoped></style>
